import { Image } from "antd";
import classNames from "classnames";
import CatLogo from "assets/images/cat_404.gif";
import { useStyles } from "./style";

const NotFoundComponent = () => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.errorPageBody)}>
      <div className="errorPageBg">404</div>
      <div className="errorPageInfo">
        <Image src={CatLogo} alt="" className="catGif" preview={false} />
        <p>
          <span>Oops!</span> This page doesn't exist.
        </p>
        <span>Please go back to the homepage.</span>
      </div>
    </div>
  );
};

export default NotFoundComponent;